import { ProductAttributeSortInput, SortEnum } from '~/modules/GraphQL/types';

export function createProductAttributeSortInput(sortData: string): ProductAttributeSortInput {
  const defaultSort: ProductAttributeSortInput = { position: SortEnum.Asc };
  
  if (!sortData || sortData === '') {
    return defaultSort;
  }

  const baseData = sortData.split(/_/gi);
  // Lấy direction là phần tử cuối, field là phần còn lại
  const direction = baseData.pop();
  const field = baseData.join('_');

  if (!field || !direction) {
    return defaultSort;
  }

  const sortDirection = direction.toUpperCase() === 'DESC' ? SortEnum.Desc : SortEnum.Asc;

  if (field === 'position') {
    return { position: sortDirection };
  }

  return {
    [field]: sortDirection
  };
}
